'use client';
import React from 'react';
import { cva, VariantProps } from 'class-variance-authority';

const styles = cva('block mb-[0.8rem] items-center font-medium text-black', {
  variants: {
    required: {
      true: 'after:content-["*"] after:ml-1 after:text-red-500',
    },
    flex: {
      true: 'flex items-center justify-between',
      default: 'block',
    },
  },
  defaultVariants: {
    required: false,
    flex: 'default',
  },
});

interface Props extends VariantProps<typeof styles> {
  value: string;
  children: React.ReactNode;
  errorMessage?: string;
  labelClasses?: string;
  flex?: boolean;
  className?: string;
  errorClassName?: string;
}

const FormLabel = ({
  children,
  value,
  errorMessage,
  required,
  labelClasses,
  flex,
  className,
  errorClassName,
}: Props) => {
  return (
    <div
      className={`${
        flex ? 'flex items-center  justify-between gap-4' : 'block'
      } w-full items-center text-input ${className}`}
    >
      <div className={flex ? 'flex justify-between' : ''}>
        <span className={styles({ required }) + ' ' + labelClasses}>
          {value}
        </span>
        {!!errorMessage && (
          <span
            className={`max-w-[18.75rem] text-[1.5rem] text-brand-red ${errorClassName}`}
          >
            {errorMessage}
          </span>
        )}
      </div>

      {children}
    </div>
  );
};

export default FormLabel;
